import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PwnedMachinesPage from './pages/PwnedMachinesPage';
import ProjectsPage from './pages/ProjectsPage';
import ToolboxPage from './pages/ToolboxPage';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from "./pages/HomePage";
import StarsCanvas from './components/StarsCanvas';
import MachineWriteup from './pages/MachineWriteup';
import './data/machines'; // Import machines data

const App = () => {
  return (
    <Router>
      <StarsCanvas/>
      <Header />
      <main>
        <Routes>
          <Route path='/' element={<HomePage />}/>
          <Route path='/about' element={<AboutPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/pwnedmachines' element={<PwnedMachinesPage />} />
          <Route path='/projects' element={<ProjectsPage />} />
          <Route path='/toolbox' element={<ToolboxPage />} />
          <Route path='*' element={<div>404 - Page Not Found</div>} />
          <Route path="/writeups/:machineId" element={<MachineWriteup />} />
          <Route path="/pwnedmachines/:machineId" element={<MachineWriteup />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;